const Rules = () => import('@/site/rules.vue')
const Introduction = () => import('@/site/rulePages/introduction.vue')
const NeedToKnow = () => import('@/site/rulePages/needToKnow.vue')
const AkashicPathsRules = () => import('@/site/rulePages/akashicPathRules.vue')
const UsingWebsite = () => import('@/site/rulePages/usingWebsite.vue')
const PatchNotes = () => import('@/site/rulePages/patchNotes.vue')
const Playtest = () => import('@/site/rulePages/playtest.vue')
const MapGenerator = () => import('@/site/rulePages/mapGenerator.vue')
const ForGMs = () => import('@/site/rulePages/forGms.vue')
const GameItems = () => import('@/site/rulePages/gameItems.vue')

export default {
    path: '/rules',
    component:Rules,
    children: [
        {
            path: 'introduction',
            component: Introduction
        },
        {
            path: 'needtoknow',
            component: NeedToKnow
        },
        {
            path: 'akashicpathsrules',
            component: AkashicPathsRules
        },
        {
            path: 'usingwebsite',
            component: UsingWebsite
        },
        {
            path: 'patchnotes',
            component: PatchNotes
        },
        {
            path: 'playtest',
            component: Playtest
        },
        {
            path: 'mapgenerator',
            component: MapGenerator
        },
        {
            path: 'forgms',
            component: ForGMs
        },
        {
            path: 'gameitems',
            component: GameItems
        },
        
    ]
}